<template>
  <div :class="{ 'nav-open': $sidebar.showSidebar }" class="wrapper">
    <side-bar
      :background-color="sidebarBackground"
      short-title="NLS"
      title="NEXT LEVEL STUDIOS"
    >
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'ni ni-tv-2 text-red',
            path: '/dashboard'
          }"
        />

        <sidebar-item :link="{name: 'User Profile', icon: 'ni ni-single-02 text-info', path: '/profile'}"/>

      </template>
    </side-bar>
    <div :data="sidebarBackground" class="main-content">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" mode="out-in" origin="center top">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      FadeTransition
    },
    data() {
      return {
        sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
      };
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      }
    }
  };
</script>
<style lang="scss">
  .wrapper {
    background-color: #f1f1f1;
  }
</style>
